import axios from "axios";

// 📌 Configuración global de Axios
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// 📌 Interceptor para añadir el token a todas las peticiones
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem("token") || "";  
    // Si no existe, token será string vacío
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  error => Promise.reject(error)
);

// 📌 Interceptor para manejar errores globales (opcional)
apiClient.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;
    if (status === 401 || status === 403) {
      localStorage.clear();
      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
